import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildsParsedInitData} from "../server/data/DirtyWildsParsedInitData";

/**
 * Class description
 *
 * Created: 2018-05-18
 * @author jonas
 */
export class DirtyWildGameMode extends GameMode {
    public static STICKY_RESPIN:string = "RESPIN";
}

export class DirtyWildsRespinZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    protected getZeroBetNumberLeft(data:DirtyWildsParsedGameData | DirtyWildsParsedInitData):number {
        if(data instanceof DirtyWildsParsedInitData) {
            return data.initSpinsRemaining;
        }
        return data.afterStopSpinsRemaining;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return true;
    }

    public shouldShowZeroBetCounter():boolean {
        return true;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode == DirtyWildGameMode.STICKY_RESPIN;
    }
}